module.exports = __webpack_public_path__ + "static/img/search_gray.d9ff343d.png";